import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {PipesModule} from './pipes/pipes.module';
import {HoverDirective} from './directives/hover.directive';
import {ClickDirective} from './directives/click.directive';
import {PreventLettersDirective} from './directives/preventLetters.directive';
import {PermissionDirective} from './directives/permission.directive';
import {YascPipeKeyValue} from './pipes/enum-convert-pipe';

const COMPONENTS: any = [
    HoverDirective,
    ClickDirective,
    PreventLettersDirective,
    PermissionDirective
];

@NgModule({
    declarations: [
        ...COMPONENTS,
    ],
    imports: [
        MatSnackBarModule,
        PipesModule,
    ],
    exports: [
        ...COMPONENTS,
        PipesModule,
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
    ],
    providers: [
        YascPipeKeyValue
    ]
})
export class SharedModule {
}
